export const INTRO_CONTENT = {
  welcome: 'WELCOME TO THE',
  boothName: 'DUPIXENT VIRTUAL EXPERIENCE',
  loadingMessage: 'LOADING, PLEASE WAIT',
}
